<template>
    <div style="background-color: white;">
        <img src="http://jho2o2.oss-cn-beijing.aliyuncs.com/test/2M2ZTB9H.jpg" width="100%" />
        <div style="text-align:center; margin: 5rem 0;">
            <van-field v-model="query.phone" type="number" label="手机号" placeholder="输入云闪付新用户手机号" class="input" />
            <van-button type="primary" size="normal" @click="simpleJobOrderDeclare" class="buyButton">参与活动</van-button>
        </div>
        <div style="width:90%;margin:0 auto;">
            注意事项：<br/>
            1.此界面输入手机号必须和云闪付拉新手机号一致，否则会影响拉新数据<br/>
            2.新用户在活动页面验证手机号,在云闪付应用完成注册绑卡,并在注册后当天完成一笔支付
        </div>
        <!--云闪付拉新暂停-->
    </div>
</template>

<script>
    import mainAPI from '@/api/main';
    import pvuvAPI from '@/api/pvuv';

    export default {
        data() {
            return {
                query: {
                    jobId: this.$route.query.jobId,
                    traderId: this.$route.query.traderId,
                    jobLinkUpPid: this.$route.query.pid,
                    phone: '',
                },
            }
        },
        methods: {
            simpleJobOrderDeclare() {
                if (!this.$myUtil.mobile(this.query.phone)) {
                    this.$toast("请输入正确的手机号");
                    return;
                }
                mainAPI.simpleJobOrderDeclare(this.query).then(() => {
                    //window.location.href = 'https://wallet.95516.com/s/wl/webV3/activity/yhtzB1/html/snsIndex.html?r=66546e0eb93ae5c713fd7635c022c9c2&code=';
                    //window.location.href = 'https://base.95516.com/s/wl/webV3/activity/yhtzbtoc/html/snsIndex.html?r=66546e0eb93ae5c713fd7635c022c9c2&code=';

                   // window.location.href = 'https://wallet.95516.com/s/wl/webV3/activity/yhtzB1/html/snsIndex.html?r=66546e0eb93ae5c713fd7635c022c9c2&code=';
                  window.location.href = 'https://interactive-marketing.jd.com/public/invite?channelNo=caoc000031';


                    
                }).catch(() => {
                });
            },
        },
        created() {
        },
        mounted() {
            pvuvAPI.addPv("jobDeclare/yunshanfuDeclare", this.query.traderId).then((result) => {
            });
        }
    }

</script>

<style lang="scss" scoped>

    .input {
        height: 5rem;
        font-size: 1.5rem;
        margin: 2rem 0;
    }

    .buyButton {
        width: 15rem;
        font-size: 1.5rem;
        font-weight: bold;
        color: #FFFFFF;
    }

</style>
